module.exports = __webpack_public_path__ + "img/Dama-logo-blue.37d71947.svg";